import React from "react"
import Container from "../container"
import styles from "./home-section.module.css"

const TermsAndConditions = () => (
    <div className={styles.prize} style={{ background: '#333' }}>
        <Container>
            <div className="text-center">
                <h3 className={styles.previewTitle}>Terms & Conditions</h3>
                <div style={{ textAlign: 'left', marginTop: '20px' }}>
                    <p><strong>Code of Conduct:</strong> Participants and spectators are expected to conduct themselves in a respectful, responsible, and inclusive manner throughout the event and to follow all safety instructions provided by event organisers and rafting guides.</p>
                    <p><strong>Photography and Recording:</strong> By attending the Faraja White Water Rafting Challenge, participants and spectators consent to being photographed, filmed, or recorded for promotional, and reporting purposes.</p>
                    <p><strong>Privacy:</strong> Any personal information collected during registration will be used solely for event administration, communication, and fundraising-related purposes and will not be shared with third parties without consent, except where required by law.</p>
                    <p><strong>Liability:</strong> While reasonable precautions will be taken to ensure the safety of all attendees, participation in rafting and related activities is at the individual's own risk. Faraja Cancer Support Trust, event partners, and service providers shall not be held liable for any personal injury, loss, damage, or theft incurred during the event.</p>
                </div>
            </div>
        </Container>
    </div>
)

export default TermsAndConditions
